// extracted by mini-css-extract-plugin
export default {"headerBorders":"styles_headerBorders__xFpj2"};